import { render, staticRenderFns } from "./EduContentRoom.vue?vue&type=template&id=61d1b99a&"
import script from "./EduContentRoom.vue?vue&type=script&lang=js&"
export * from "./EduContentRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports